import {
  ListSignedConsentDocumentsResponse,
  SignedConsentDocumentsRequest,
} from "~/providers/types/consentDocuments";
import {
  AddConsentDocumentRequest,
  ConsentDocumentsRequest,
  DeleteConsentDocumentRequest,
  ListConsentDocumentResponse,
  UpdateConsentDocumentRequest,
} from "../types/consentDocuments";
import { api } from "./axios";

export const listConsentDocuments = async ({
  organizationId,
}: ConsentDocumentsRequest) => {
  const response = await api.get<ListConsentDocumentResponse[]>(
    `v1/organizations/${organizationId}/consent-forms`,
  );

  return response.data;
};

export const listSignedConsentDocuments = async ({
  organizationId,
  patientId,
}: SignedConsentDocumentsRequest) => {
  const response = await api.get<ListSignedConsentDocumentsResponse[]>(
    `/v1/organizations/${organizationId}/patients/${patientId}/consent-forms/signatures`,
  );

  return response.data;
};

export const addConsentDocument = async ({
  organizationId,
  ...request
}: AddConsentDocumentRequest) => {
  const formdata = new FormData();
  formdata.append("name", request.name);
  formdata.append("file", request.file);

  const { data } = await api.post<ListConsentDocumentResponse>(
    `/v1/organizations/${organizationId}/consent-forms`,
    formdata,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
};

export const updateConsentDocument = async ({
  organizationId,
  consentId,
  ...request
}: UpdateConsentDocumentRequest) => {
  const formdata = new FormData();

  if (request.name) {
    formdata.append("name", request.name);
  }

  if (request.file) {
    formdata.append("file", request.file);
  }

  const { data } = await api.patch<ListConsentDocumentResponse>(
    `/v1/organizations/${organizationId}/consent-forms/${consentId}`,
    formdata,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return data;
};

export const deleteConsentDocument = async ({
  organizationId,
  consentId,
}: DeleteConsentDocumentRequest) => {
  const response = await api.delete(
    `/v1/organizations/${organizationId}/consent-forms/${consentId}`,
  );
  return response;
};
